// -- basic library --
import React from 'react';
import { RoundedButtonProps } from 'shared/components/atoms/RoundedButton';
import { InputBaseTable } from 'shared/components/molecules/Table/InputBaseTable';
import { TableBodyClickType, TableHeaderType } from 'shared/components/molecules/Table/type';

// -- type declaration --

interface Params {
  bodies: TableHeartbeatType[];
  selected_bodies: TableHeartbeatType[];
  handleCheckClick: (datas: TableHeartbeatType[]) => void;
  buttons?: RoundedButtonProps[];
}

export interface TableHeartbeatType {
  id: string;
  key: TableBodyClickType;
  name: string;
  description: string;
  default_schedule: string;
  additionals: string;
  required: string;
  is_hidden: string;
}

// -- external functions --

const headers: TableHeaderType[] = [
  {
    id: 'key',
    label: 'キー',
  },
  {
    id: 'name',
    label: '表示名',
  },
  {
    id: 'description',
    label: '説明',
  },
  {
    id: 'default_schedule',
    label: 'デフォルト値',
  },
  {
    id: 'additionals',
    label: 'JSON',
  },
  {
    id: 'required',
    label: '必須',
  },
  {
    id: 'is_hidden',
    label: '非表示',
  },
];

// -- main component --
const HeartbeatTable: React.FC<Params> = (params) => {
  // -- render part --
  return <InputBaseTable {...params} table_name='heartbeat' headers={headers} />;
};

// -- styled components --

// -- finally export part --
export default HeartbeatTable;
